var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"photography-page"}},[_c('PhotographyImages'),_c('Album')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }